import { createBrowserHistory } from 'history';

export type { History } from 'history';
const history = createBrowserHistory();

export default history;
